// extracted by mini-css-extract-plugin
export var container = "SlideInMenuHeader-module--container--2UT_1";
export var title = "SlideInMenuHeader-module--title--8Jrl5";
export var closeButton = "SlideInMenuHeader-module--closeButton--5Hsf8";